<template>
  <Upload
    :action="dataObj.host"
    :data="dataObj"
    :format="['jpg','jpeg','png','bmp']"
    :before-upload="beforeUpload"
    :on-success="handleUploadSuccess"
    :show-upload-list="false">
    <slot></slot>
  </Upload>
</template>

<script>
  import { policy } from '@/api/oss'
  export default {
    name: 'SingleUpload',
    data() {
      return {
        dataObj: {
          policy: '',
          signature: '',
          key: '',
          ossaccessKeyId: '',
          dir: '',
          host: 'https://haihaigo.oss-cn-shenzhen.aliyuncs.com'
        },
        filename: null
      }
    },
    methods: {
      beforeUpload (file) {
        let _self = this;
        this.filename = this.random_string(20)
        return new Promise((resolve, reject) => {
          policy().then(response => {
            _self.dataObj.policy = response.data.policy
            _self.dataObj.signature = response.data.signature
            _self.dataObj.ossaccessKeyId = response.data.accessKeyId
            _self.dataObj.key = response.data.dir + '/' + this.filename
            _self.dataObj.dir = response.data.dir
            _self.dataObj.host = response.data.host
            resolve(true)
          }).catch(err => {
            console.log(err)
            reject(false)
          })
        })

      },
      handleUploadSuccess (res, file) {
        let url = this.dataObj.host + '/' + this.dataObj.dir + '/' + this.filename
        this.$emit('handleUpload', url)
      },
      random_string (len) {
        len = len || 32
        var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
        var maxPos = chars.length
        var pwd = ''
        for (let i = 0; i < len; i++) {
          pwd += chars.charAt(Math.floor(Math.random() * maxPos))
        }
        return pwd
      }

    }
  }
</script>

<style scoped>

</style>
